export default __webpack_public_path__ + "static/media/like-filled.d304f42f.svg";